
import { Options, Vue } from 'vue-class-component';
import { CompanyGarmentCompositionClient } from '@/services/Services';
import InfoModal from '@/components/modals/infoModal.vue';
import store from '@/store';
import * as OM from '@/Model';
import * as VM from '@/viewModel';

@Options({
    components: {}
})
export default class GarmentCompositions extends Vue {

    garments: OM.TextIdentifier[] = [];
    subTypesByGarment: { [garmentIdentifier: string]: OM.GarmentSubTypeVM[] } = {};

    loaded: boolean = false;

    created() {
        this.init();
    }

    get isReadOnly() {
        return store.state.loggedUser.role == VM.Roles.ReadOnly;
    }

    init() {
        this.loaded = false;

        CompanyGarmentCompositionClient.getCustomizableGarments()
        .then(garments => {
            this.garments = garments;

            let calls = garments.map(garment => CompanyGarmentCompositionClient.getSubTypes(garment.identifier));

            Promise.all(calls)
            .then(results => {
                this.subTypesByGarment = {};
                garments.forEach((garment, index) => {
                    this.subTypesByGarment[garment.identifier] = results[index];
                })
                this.loaded = true;
            })
            .catch(() => {
                this.garments = [];
                this.loaded = true;
            })
        })
        .catch(() => {
            this.garments = [];
            this.loaded = true;
        })
    }

    edit(garment: OM.TextIdentifier, item: OM.GarmentSubTypeVM) {
        this.$router.push('/my-compositions/' + garment.identifier + '/' + encodeURIComponent(item.subType));
    }

    confirmReset(garment: OM.TextIdentifier, item: OM.GarmentSubTypeVM) {
        this.$opModal.show(InfoModal, {
            text: this.$localizationService.getLocalizedValue("Reset to Edmond", "Reset to Edmond"),
            subtitle: this.$localizationService.getLocalizedValue(
                "Your custom composition for this sub-type will be deleted. New calculations will use the Edmond default. Estimations already created are not affected.",
                "Your custom composition for this sub-type will be deleted. New calculations will use the Edmond default. Estimations already created are not affected."),
            confirm: this.$localizationService.getLocalizedValue("Confirm", "Confirm"),
            deny: this.$localizationService.getLocalizedValue("Cancel", "Cancel"),
            confirmCb: () => {
                let model = new OM.DeleteCompanyGarmentCompositionVM();
                model.garmentIdentifier = garment.identifier;
                model.subType = item.subType;

                CompanyGarmentCompositionClient.deleteComposition(model)
                .then(() => {
                    this.$opModal.closeLast();
                    this.init();
                })
                .catch(() => {
                    this.$opModal.closeLast();
                    this.$opModal.show(InfoModal, {
                        text: this.$localizationService.getLocalizedValue("Error", "Error"),
                        subtitle: this.$localizationService.getLocalizedValue("Unable to reset the composition", "Unable to reset the composition"),
                        deny: this.$localizationService.getLocalizedValue("Close", "Close"),
                        denyCb: () => {
                            this.$opModal.closeLast();
                        }
                    })
                })
            },
            denyCb: () => {
                this.$opModal.closeLast();
            }
        })
    }
}
